export const checkPartAvailabity = (
  groups: TCategories,
  category: string | undefined,
  subCategory?: string | undefined
) => {
  const groupCategory = groups.filter((c) => category === c.slug);
  if (groupCategory.length === 0) {
    return {
      is_pro_allowed: false,
      is_allowed: false,
    };
  }
  const allParts: TPart[] = Object.values(
    groupCategory[0].parts
  ).flat() as TPart[];

  const selectedPart = allParts.find(
    (p) => p.slug === subCategory || p.part_en === subCategory
  );
  if (!selectedPart) {
    return {
      is_pro_allowed: false,
      is_allowed: false,
    };
  }

  return {
    is_pro_allowed: selectedPart.is_pro_allowed,
    is_allowed: selectedPart.is_allowed,
  };
};
